$(function(){

    const language = $('html')[0].lang;
    const myProject = require('./_data/myProject');
    const envSettings = myProject[myProject.environment];

    const Uris = {
        jsonSearch : envSettings.server + "/json/search",
//        substancePageFi : envSettings.staticFilesRootPath + "/fi/laakevalmiste/",
//        substancePageEn : envSettings.staticFilesRootPath + "/en/substance/",
//        substancePageSe : envSettings.staticFilesRootPath + "/sv/lakemedel/",
        substancePageFi : "/fi/laakevalmiste/",
        substancePageEn : "/en/substance/",
        substancePageSe : "/sv/lakemedel/",
    }
    
    
    function showLoadingSpinner(){
        let spinner = '<div class="border p-2"><div class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div></div>';
        $("#searchDrowdown").append(spinner);
    }

    function hideResultsAndLoadingSpinner(){
        $("#searchDrowdown").empty();
    }


    function search(){
       
        hideResultsAndLoadingSpinner();

        let searchTerm = $("#searchInput").val();
        if(searchTerm.length < 3){
                console.log(searchTerm.length + ' is too smalla searchTerm.length.  Do nothing');
                return;
        }
        showLoadingSpinner();

        $.ajax({
            url: Uris.jsonSearch, method:"GET",data: { q: searchTerm},cache : false
        })
        .done(function( data ) {
            console.log("success");
            console.log(data);
            hideResultsAndLoadingSpinner();

            if(data === "ERROR" || data === "NO_RESULTS"){
                console.log(data + ' do nothing');
                return;
            }


            console.log('start loop');
            $.each(data,function(index,dataRow){
                dataRow.id;
                dataRow.name; // example: BURANA
                dataRow.type; // TRADENAMES
                dataRow.dosageForm; // tabletti, kalvopäällysteinen
                dataRow.dosageFormEn; 
                dataRow.dosageFormSv;
                dataRow.strengthText; // 400.0 mg
                dataRow.strengthTextEn;
                dataRow.strengthTextSv;
                dataRow.substances; // ibuprofeiini
                dataRow.substancesEn;
                dataRow.substancesSv;
                console.log(dataRow.name);

                var rowLinkHtml = "";
                if(language === "fi"){
                    rowLinkHtml = dataRow.name + " " + dataRow.substances + "<br>" + dataRow.dosageForm + " " + dataRow.strengthText;  
                }else if(language === "sv"){
                    rowLinkHtml = dataRow.name + " " + dataRow.substancesSv + "<br>" + dataRow.dosageFormSv + " " + dataRow.strengthTextSv;  
                }else if(language === "en"){
                    rowLinkHtml = dataRow.name + " " + dataRow.substancesEn + "<br>" + dataRow.dosageFormEn + " " + dataRow.strengthTextEn;  
                }
                   
                let link = "";
                if(language === "fi"){
                    link = Uris.substancePageFi +"?id="+  dataRow.id;
                }else if(language === "sv"){
                    link = Uris.substancePageSe +"?id="+  dataRow.id;
                }else if(language === "en"){
                    link = Uris.substancePageEn +"?id="+  dataRow.id;
                }

                $("#searchDrowdown")
                    .append($("<div style='cursor: pointer;' tabindex=0><a></a></div>").attr("class","border p-2")
                    .html(rowLinkHtml)
                    .on("click", function(event){
                        window.location.href = link;
                       })
                    .on("keypress", function(event){
                        window.location.href = link;
                    })
                );
            }); 

        })
        .fail(function(err){
            hideResultsAndLoadingSpinner();
            console.log("fail");
            console.log(err);
        });

    }


    $('#searchInput').on('keyup',function(e){
        // get keycode of current keypress event
        let code = (e.keyCode || e.which);
        // do nothing if it's an arrow key
        if(code == 37 || code == 38 || code == 39 || code == 40) {
            return;
        }

        search();
    });

});
